var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "setting-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8333 18.9583C15.4917 18.9583 15.2083 18.675 15.2083 18.3333V9.16667C15.2083 8.825 15.4917 8.54167 15.8333 8.54167C16.175 8.54167 16.4583 8.825 16.4583 9.16667V18.3333C16.4583 18.675 16.175 18.9583 15.8333 18.9583Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.8333 6.45833C15.4917 6.45833 15.2083 6.175 15.2083 5.83333V1.66667C15.2083 1.325 15.4917 1.04167 15.8333 1.04167C16.175 1.04167 16.4583 1.325 16.4583 1.66667V5.83333C16.4583 6.175 16.175 6.45833 15.8333 6.45833Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 18.9583C9.65833 18.9583 9.375 18.675 9.375 18.3333V14.1667C9.375 13.825 9.65833 13.5417 10 13.5417C10.3417 13.5417 10.625 13.825 10.625 14.1667V18.3333C10.625 18.675 10.3417 18.9583 10 18.9583Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 11.4583C9.65833 11.4583 9.375 11.175 9.375 10.8333V1.66667C9.375 1.325 9.65833 1.04167 10 1.04167C10.3417 1.04167 10.625 1.325 10.625 1.66667V10.8333C10.625 11.175 10.3417 11.4583 10 11.4583Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.16667 18.9583C3.825 18.9583 3.54167 18.675 3.54167 18.3333V9.16667C3.54167 8.825 3.825 8.54167 4.16667 8.54167C4.50833 8.54167 4.79167 8.825 4.79167 9.16667V18.3333C4.79167 18.675 4.50833 18.9583 4.16667 18.9583Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.16667 6.45833C3.825 6.45833 3.54167 6.175 3.54167 5.83333V1.66667C3.54167 1.325 3.825 1.04167 4.16667 1.04167C4.50833 1.04167 4.79167 1.325 4.79167 1.66667V5.83333C4.79167 6.175 4.50833 6.45833 4.16667 6.45833Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.83333 9.79167H2.5C2.15833 9.79167 1.875 9.50833 1.875 9.16667C1.875 8.825 2.15833 8.54167 2.5 8.54167H5.83333C6.175 8.54167 6.45833 8.825 6.45833 9.16667C6.45833 9.50833 6.175 9.79167 5.83333 9.79167Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.5 9.79167H14.1667C13.825 9.79167 13.5417 9.50833 13.5417 9.16667C13.5417 8.825 13.825 8.54167 14.1667 8.54167H17.5C17.8417 8.54167 18.125 8.825 18.125 9.16667C18.125 9.50833 17.8417 9.79167 17.5 9.79167Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.6667 11.4583H8.33333C7.99167 11.4583 7.70833 11.175 7.70833 10.8333C7.70833 10.4917 7.99167 10.2083 8.33333 10.2083H11.6667C12.0083 10.2083 12.2917 10.4917 12.2917 10.8333C12.2917 11.175 12.0083 11.4583 11.6667 11.4583Z",
    fill: "#3451F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10",
    opacity: 0
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settings.4c14f9e67e1145784d67e57ee7613448.svg";